import { render } from "./Acquisition.vue?vue&type=template&id=12ede716&scoped=true"
import script from "./Acquisition.vue?vue&type=script&lang=js"
export * from "./Acquisition.vue?vue&type=script&lang=js"

import "./Acquisition.vue?vue&type=style&index=0&id=12ede716&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ede716"]])

export default __exports__